<template>
  <div class="circle" ref="circle" />
</template>

<script>
import EventBus from '@/eventBus'

export default {
  props: {
    countTimeToAnswer: {
      type: String,
      default: null,
    },
  },
  data() {
    return {}
  },
  mounted() {
    this.resetTimeToAnswer(this.countTimeToAnswer)
    EventBus.$on('resetCycle', (value) => this.resetTimeToAnswer(value))
  },
  destroyed() {
    EventBus.$off('resetCycle')
  },
  methods: {
    resetTimeToAnswer(value) {
      this.$refs.circle.style.animation = 'none'
      this.$refs.circle.focus()
      this.$refs.circle.style.animation = null
      this.$refs.circle.style.animationDuration = value
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

@keyframes progress {
  0% {
    clip-path: polygon(50% 50%, 50% -50%, 150% 50%, 50% 150%, -50% 50%, 50% -50%);
  }
  25% {
    clip-path: polygon(50% 50%, 150% 50%, 50% 150%, -50% 50%, 50% -50%, 50% -50%);
  }
  50% {
    clip-path: polygon(50% 50%, 50% 150%, -50% 50%, 50% -50%, 50% -50%, 50% -50%);
  }
  75% {
    clip-path: polygon(50% 50%, -50% 50%, 50% -50%, 50% -50%, 50% -50%, 50% -50%);
  }
  100% {
    clip-path: polygon(50% 50%, 50% -50%, 50% -50%, 50% -50%, 50% -50%, 50% -50%);
  }
}

.circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-block;
  border: solid 5px $primary-color;
  animation: progress linear forwards;
}
</style>
